module.exports = __webpack_public_path__ + "static/media/krentsel-website.ea47e122.png";